module.exports = __webpack_public_path__ + "static/src/content/images/processed/400/Pompeii.0bb6ad5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/400/Pompeii.jpg
// module id = W10G
// module chunks = 0